import { useTranslation } from '@kgc/i18n';

type PaymentMethod = 'CASH' | 'CARD' | 'TRANSFER';

interface PaymentMethodSelectProps {
  value: PaymentMethod;
  onChange: (method: PaymentMethod) => void;
  disabled?: boolean | undefined;
}

export function PaymentMethodSelect({ value, onChange, disabled }: PaymentMethodSelectProps) {
  const { t } = useTranslation();

  const methods: { method: PaymentMethod; label: string; testId: string }[] = [
    { method: 'CASH', label: t('rental.payment.cash'), testId: 'payment-method-cash' },
    { method: 'CARD', label: t('rental.payment.card'), testId: 'payment-method-card' },
    { method: 'TRANSFER', label: t('rental.payment.transfer'), testId: 'payment-method-transfer' },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {methods.map(({ method, label, testId }) => (
        <button
          key={method}
          type="button"
          data-testid={testId}
          disabled={disabled}
          onClick={() => onChange(method)}
          className={`rounded-lg border-2 p-3 text-center transition-all ${
            value === method ? 'border-primary bg-primary/10' : 'border-input hover:border-input'
          }`}
        >
          <p className="text-sm font-medium">{label}</p>
        </button>
      ))}
    </div>
  );
}
